import { createFileRoute } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { OrganizationalUnitsTable } from '~/components/settings/masterData/organizationalUnit/OrganizationalUnitsTable';

import { routeParams, validateSearch } from './-routeParams';

export const Route = createFileRoute('/(main)/settings/masterdata/org-groups/')(
  {
    beforeLoad: createProtectedRoute({
      routePath: '/settings/masterdata/org-groups',
      ...routeParams,
    }),
    component: OrganizationalUnitsTable,
    validateSearch,
  },
);

export const MASTERDATA_ORG_GROUPS = buildRouteExport({
  Route,
  ...routeParams,
});
